import {
	creditRanges
} from '../config/settings.js';
import { trackCADREvent } from '../events/trackEvent.js';

export const buildPaymentCashObject = (listedPrice) => ({
	cash: {
		offerPrice: listedPrice
	},
});

export const buildPaymentFinanceObject = (listedPrice, downPayment, loanTerm) => ({
	finance: {
		offerPrice: listedPrice,
		downPayment,
		selectedTerm: Number(loanTerm)
	},
});

export const buildPaymentLeaseObject = (listedPrice, downPayment, leaseTerm, leaseMileageRange) => ({
	lease: {
		offerPrice: listedPrice,
		downPayment,
		selectedTerm: Number(leaseTerm),
		annualMiles: leaseMileageRange
	},
});

export const buildPaymentObject = (walletData, listedPrice) => {
	const [ creditScoreHigh ] =  creditRanges[walletData.creditType];
	const vehicleOfferPrice =  walletData.penciling?.offerPrice ?? listedPrice;
	const downPayment = walletData.downPayment || 0;
	const payment = {
		...buildPaymentCashObject(vehicleOfferPrice),
		...buildPaymentFinanceObject(vehicleOfferPrice, downPayment, walletData.loanTerm),
		...buildPaymentLeaseObject(vehicleOfferPrice, downPayment, walletData.leaseTerm, walletData.leaseMileageRange),
		// Fallback to finance because if dealType is null or blank
		selectedOfferType: walletData.dealType || 'finance',
		creditScore: creditScoreHigh
	};
	return payment;
}
// TODO - for future trade in work
export const buildTradeObject = (walletData) => {

	const trade = {
		value: walletData.tradeIn.value,
		amountOwed: walletData.tradeIn.amountOwed,
		condition: walletData.tradeIn.condition || undefined,
		isNetTradeAppliedToFinancing: walletData.tradeIn.isNetTradeAppliedToFinancing,
		make: walletData.tradeIn.make,
		mileage: walletData.tradeIn.mileage,
		model: walletData.tradeIn.model,
		trim: walletData.tradeIn.trim,
		vin: walletData.tradeIn.vin,
		year: walletData.tradeIn.year,
		source: walletData.tradeIn.source
	}
	return trade;
}

export const buildSDPInitObject = (walletData, route, refreshDsAfterSdpClose) => {
	const digitalRetailObject = window.CADigitalRetailObject;
	const {
		listedPrice,
		mileage,
		condition,
		retailPrice,
		year,
		chromeStyleId,
		exteriorColor,
		interiorColor,
		listingCode,
		make,
		model,
		trim,
		vin,
		uuid,
		vdpUrl,
		imgUrl
	} = digitalRetailObject.vehicleData;

	const init = {
		hooks: {
			onLoadedFunction: null,
			onHidingFunction: () => {
				// handle direct SDP entry points like Test Drive, Apply for financing
				if (refreshDsAfterSdpClose && typeof window.refreshAccelerateWidget === 'function') {
					window.refreshAccelerateWidget();
				}
			},
			// Adds tracking within SDP for GA
			onTrack: (event, eventAction, eventData) => {
				const data = eventData === undefined ? undefined : JSON.stringify(eventData);
				trackCADREvent(event, data);
			}
		},
		version: digitalRetailObject.version,
		isMobile: digitalRetailObject.isMobile,
		route,
		offer: {
			vehicle: {
				listedPrice,
				mileage,
				condition,
				retailPrice,
				year,
				chromeStyleId,
				exteriorColor,
				interiorColor,
				listingCode,
				make,
				model,
				trim,
				vin,
				uuid,
				urls: {
					vdpUrl,
					imageUrl: decodeURIComponent(imgUrl), // image url can be decoded on this side
					vehicleUrl: vdpUrl
				}
			},
			dealer: {
				dnaAccountId: digitalRetailObject.accountId,
				id: Number(digitalRetailObject.dealerId),
				sponsor: 'ddc'
			},
			payment: buildPaymentObject(walletData, listedPrice),
			trade: walletData.tradeIn.value ? buildTradeObject(walletData) : undefined,
			shopper: {},
			source: 'SPONSOR',
			walletId: walletData.walletId
		}
	};
	return init;
}
